const BOX_TYPE = 'box'
const faceInfo = [
  { name: 'north', wIdx: 0, hIdx: 1 },
  { name: 'south', wIdx: 0, hIdx: 1 },
  { name: 'east', wIdx: 2, hIdx: 1 },
  { name: 'west', wIdx: 2, hIdx: 1 },
  { name: 'up', wIdx: 0, hIdx: 2 },
  { name: 'down', wIdx: 0, hIdx: 2 },
]

// Base UVs: BL, BR, TR, TL (counter-clockwise from bottom-left)
const BASE_UVS = [
  [0, 1], // BL
  [1, 1], // BR
  [1, 0], // TR
  [0, 0], // TL
]

// Rotation remaps indices: rotation N means rotate clockwise N*90 degrees
const ROTATION_INDEX_MAP = [
  [0, 1, 2, 3], // rotation 0: no change
  [3, 0, 1, 2], // rotation 1 (90° CW)
  [2, 3, 0, 1], // rotation 2 (180°)
  [1, 2, 3, 0], // rotation 3 (270° CW)
]

function traverse(node, insert) {
  if (node.type === BOX_TYPE) {
    for (const info of faceInfo) {
      const face = node.faces[info.name]

      // Get face dimensions in pixels
      const faceW = node.rawSize ? node.rawSize[info.wIdx] : node.size[info.wIdx]
      const faceH = node.rawSize ? node.rawSize[info.hIdx] : node.size[info.hIdx]

      if (!faceW || !faceH) continue

      // Apply density multiplier
      const density = face.density ?? 1
      const w = faceW * density
      const h = faceH * density

      // Get texture region origin
      const x = face.x ?? 0
      const y = face.y ?? 0
      const rotation = face.rotation ?? 0
      const flipX = face.flipX ?? false
      const flipY = face.flipY ?? false

      // Insert into atlas
      face.tileId = insert(x, y, w, h)

      // Generate UVs with rotation applied
      const rotationMap = ROTATION_INDEX_MAP[rotation % 4]
      face.uv = [0, 1, 2, 3].map(i => {
        const srcIdx = rotationMap[i]
        let [u, v] = BASE_UVS[srcIdx]

        // Apply flips after rotation
        if (flipX) u = 1 - u
        if (flipY) v = 1 - v

        return [u, v]
      })
    }
  }

  for (const child of node.children) {
    traverse(child, insert)
  }
}

export function bindTextureToAsset(texture, asset, atlas) {
  if (!texture) return
  const url = texture.url
  const insert = (x, y, w, h) => {
    return atlas.insert(url, x, y, w, h)
  }
  traverse(asset.model.root, insert)
}
